const MOBILE_HEADER_HEIGHT_PX = 49;
const MOBILE_BOTTOM_NAV_HEIGHT_PX = 63;
const TABLET_PORTRAIT_HEADER_HEIGHT_PX = 80;
const SMALL_DESKTOP_HEADER_HEIGHT_PX = 84;

export default {
  icons: {
    lock: 'lock',
  },
  layout: {
    mobileHeaderHeightPx: MOBILE_HEADER_HEIGHT_PX,
    mobileBottomNavHeightPx: MOBILE_BOTTOM_NAV_HEIGHT_PX,
    mobileHeaderAndBottomNavHeightPx: MOBILE_HEADER_HEIGHT_PX + MOBILE_BOTTOM_NAV_HEIGHT_PX,
    tabletPortraitHeaderHeightPx: TABLET_PORTRAIT_HEADER_HEIGHT_PX,
    smallDesktopHeaderHeightPx: SMALL_DESKTOP_HEADER_HEIGHT_PX,
  },
};
